export default [{
  path: '/unAuthorized',
  name: 'unAuthorized',
  show: false,
  meta: {
    code: 'unAuthorized',
    title: '未授权',
    structure: 'LEFT_RIGHT',
    authorized: true,
  },
  component: resolve => require(['@/views/errorpage/UnAuthorized'], resolve)
},
{
  path: '*',
  name: 'notFound',
  meta: {
    title: '404',
    code: 'notFound',
    structure: 'LEFT_RIGHT',
    authorized: true,
  },
  component: resolve => require(['@/views/errorpage/NotFound'], resolve)
}
]